import { times } from "lodash-es";

import { Skeleton } from "src/design-system/Skeleton";

export const FolderListSkeleton: React.FC = () => {
  const skeletonCount = 7;
  return (
    <ul className="mt-3 ml-5 flex flex-col gap-5">
      {times(skeletonCount, (i) => (
        <Skeleton key={i} height="h-3" width="w-32" />
      ))}
    </ul>
  );
};
